import React from "react";
import { NavLink } from "react-router-dom";

const activeStyle = { color: "rgba(255,127,9,1)" };
const inactiveStyle = { color: "rgba(242,242,242,1)" };

export default function ArticleSidebar() {
  return (
    <div className="p-6 inline-flex flex-col items-start justify-start w-[250px] h-full bg-[rgba(35,34,35,1)]">
      <div className="w-full gap-2 inline-flex flex-col items-start justify-start flex-grow h-[847px]">
        <NavLink
          style={({ isActive }) => (isActive ? activeStyle : inactiveStyle)}
          to="/articles/quit-school"
          className="text-xs font-medium inline font-['Quicksand'] leading-[normal] "
        >
          Why I Quit School
        </NavLink>
        <NavLink
          style={({ isActive }) => (isActive ? activeStyle : inactiveStyle)}
          to="/articles/ten-mins-yc"
          className="text-xs font-medium inline font-['Quicksand'] leading-[normal]"
        >
          10 Mins in Y Combinator
        </NavLink>
      </div>
      {/* TODO: Make these icons appear but I'm way too lazy */}
      <div className="w-full inline-flex flex-row items-start justify-between hidden">
        <div className="w-6 h-6 relative">
          <div className="w-6 absolute top-1 h-[16.01px] left-[0]">
            <div className="absolute left-0 right-[-4.16%] top-[0.03%] bottom-[-12.46%]">
              <svg
                width="100%"
                height="100%"
                preserveAspectRatio="none"
                viewBox="0 0 25 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M23.5 3.50701C23.3641 3.02225 23.0994 2.58336 22.734 2.23702C22.3583 1.88002 21.8978 1.62465 21.396 1.49501C19.518 1.00001 11.994 1.00002 11.994 1.00002C8.85734 0.964328 5.72144 1.12129 2.60401 1.47001C2.1022 1.60923 1.64257 1.8703 1.26601 2.23002C0.896007 2.58601 0.628007 3.02502 0.488007 3.50602C0.1517 5.31776 -0.0117011 7.15736 6.83166e-06 9.00002C-0.0119932 10.841 0.151007 12.68 0.488007 14.494C0.625007 14.973 0.892007 15.41 1.26301 15.763C1.63401 16.116 2.09601 16.371 2.60401 16.506C4.50701 17 11.994 17 11.994 17C15.1347 17.0358 18.2746 16.8788 21.396 16.53C21.8978 16.4004 22.3583 16.145 22.734 15.788C23.0993 15.4417 23.3637 15.0028 23.499 14.518C23.8441 12.707 24.0119 10.8666 24 9.02302C24.026 7.17162 23.8584 5.32258 23.5 3.50602V3.50701ZM9.60201 12.424V5.57701L15.862 9.00102L9.60201 12.424Z"
                  fill="#F2F2F2"
                ></path>
              </svg>
            </div>
          </div>
        </div>
        <div className="h-6 w-[25px]">
          <svg
            width="100%"
            height="100%"
            preserveAspectRatio="none"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20.3334 3H4.33337C4.06816 3 3.8138 3.10536 3.62627 3.29289C3.43873 3.48043 3.33337 3.73478 3.33337 4V20C3.33337 20.2652 3.43873 20.5196 3.62627 20.7071C3.8138 20.8946 4.06816 21 4.33337 21H20.3334C20.5986 21 20.8529 20.8946 21.0405 20.7071C21.228 20.5196 21.3334 20.2652 21.3334 20V4C21.3334 3.73478 21.228 3.48043 21.0405 3.29289C20.8529 3.10536 20.5986 3 20.3334 3ZM8.67237 18.337H6.00037V9.747H8.67237V18.337ZM7.33637 8.574C6.92582 8.574 6.53208 8.41091 6.24177 8.1206C5.95147 7.8303 5.78837 7.43655 5.78837 7.026C5.78837 6.61544 5.95147 6.22171 6.24177 5.9314C6.53208 5.64109 6.92582 5.478 7.33637 5.478C7.74693 5.478 8.14067 5.64109 8.43097 5.9314C8.72128 6.22171 8.88437 6.61544 8.88437 7.026C8.88437 7.43655 8.72128 7.8303 8.43097 8.1206C8.14067 8.41091 7.74693 8.574 7.33637 8.574ZM18.6714 18.337H16.0024V14.16C16.0024 13.164 15.9844 11.883 14.6144 11.883C13.2244 11.883 13.0134 12.969 13.0134 14.09V18.338H10.3464V9.748H12.9064V10.922H12.9434C13.2984 10.247 14.1704 9.535 15.4674 9.535C18.1714 9.535 18.6704 11.313 18.6704 13.627V18.337H18.6714Z"
              fill="#F2F2F2"
            ></path>
          </svg>
        </div>
        <div className="w-6 h-6 relative">
          <div className="absolute bottom-0 left-[8.33%] right-[-4.17%] top-[8.33%]">
            <svg
              width="100%"
              height="100%"
              preserveAspectRatio="none"
              viewBox="0 0 23 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.6666 21C17.1895 21 21.6666 16.5228 21.6666 11C21.6666 5.47715 17.1895 1 11.6666 1C6.14378 1 1.66663 5.47715 1.66663 11C1.66663 16.5228 6.14378 21 11.6666 21Z"
                stroke="#F2F2F2"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
              <path
                d="M7.66663 11C7.66663 16.5228 9.45749 21 11.6666 21C13.8758 21 15.6666 16.5228 15.6666 11C15.6666 5.47715 13.8758 1 11.6666 1C9.45749 1 7.66663 5.47715 7.66663 11Z"
                stroke="#F2F2F2"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
              <path
                d="M1.66663 11H21.6666"
                stroke="#F2F2F2"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
          </div>
        </div>
        <div className="w-6 h-6">
          <svg
            width="100%"
            height="100%"
            preserveAspectRatio="none"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.415 14.382C17.117 14.233 15.656 13.515 15.384 13.415C15.112 13.316 14.914 13.267 14.715 13.565C14.517 13.861 13.948 14.531 13.775 14.729C13.601 14.928 13.428 14.952 13.131 14.804C12.834 14.654 11.876 14.341 10.741 13.329C9.858 12.541 9.261 11.568 9.088 11.27C8.915 10.973 9.069 10.812 9.218 10.664C9.352 10.531 9.515 10.317 9.664 10.144C9.813 9.96998 9.862 9.84598 9.961 9.64698C10.061 9.44898 10.011 9.27598 9.936 9.12698C9.862 8.97798 9.268 7.51498 9.02 6.91998C8.779 6.34098 8.534 6.41998 8.352 6.40998C8.178 6.40198 7.98 6.39998 7.782 6.39998C7.584 6.39998 7.262 6.47398 6.99 6.77198C6.717 7.06898 5.95 7.78798 5.95 9.25098C5.95 10.713 7.014 12.126 7.163 12.325C7.312 12.523 9.258 15.525 12.239 16.812C12.949 17.118 13.502 17.301 13.933 17.437C14.645 17.664 15.293 17.632 15.805 17.555C16.375 17.47 17.563 16.836 17.811 16.142C18.058 15.448 18.058 14.853 17.984 14.729C17.91 14.605 17.712 14.531 17.414 14.382H17.415ZM11.993 21.785H11.989C10.2184 21.7853 8.48037 21.3093 6.957 20.407L6.597 20.193L2.855 21.175L3.854 17.527L3.619 17.153C2.62914 15.5773 2.10529 13.7538 2.108 11.893C2.11 6.44298 6.544 2.00898 11.997 2.00898C14.637 2.00898 17.119 3.03898 18.985 4.90698C19.9054 5.82356 20.6349 6.91355 21.1313 8.11388C21.6277 9.31421 21.8811 10.6011 21.877 11.9C21.875 17.35 17.441 21.785 11.993 21.785ZM20.405 3.48798C19.3032 2.3789 17.9922 1.49952 16.5481 0.90078C15.1039 0.302044 13.5553 -0.00413728 11.992 -2.00576e-05C5.438 -2.00576e-05 0.102 5.33498 0.1 11.892C0.096963 13.9787 0.644374 16.0294 1.687 17.837L0 24L6.304 22.346C8.04787 23.2961 10.0021 23.7939 11.988 23.794H11.993C18.547 23.794 23.883 18.459 23.885 11.901C23.8898 10.3383 23.5848 8.79008 22.9874 7.34601C22.3901 5.90195 21.5124 4.59065 20.405 3.48798Z"
              fill="#F2F2F2"
            ></path>
          </svg>
        </div>
      </div>
    </div>
  );
}
